// Utility functions for easy access to notifications from anywhere in the app
// These provide backwards compatibility with the old alert() and confirm() usage

// Simple alert replacement
export function alert(message, options = {}) {
  return window.NotificationService?.alert(message, options) || 
         Promise.resolve(window.alert(message))
}

// Simple confirm replacement  
export function confirm(title, text = null, options = {}) {
  return window.NotificationService?.confirm(title, text, options) ||
         Promise.resolve(window.confirm(title + (text ? "\n" + text : "")))
}

// Delete confirmation
export function confirmDelete(title, text = null, options = {}) {
  return window.NotificationService?.confirmDelete(title, text, options) ||
         Promise.resolve(window.confirm(title + (text ? "\n" + text : "")))
}

// Success notification
export function success(message, text = null, options = {}) {
  return window.NotificationService?.success(message, text, options) ||
         window.alert(message)
}

// Error notification
export function error(message, text = null, options = {}) {
  return window.NotificationService?.error(message, text, options) ||
         window.alert(message)
}

// Warning notification
export function warning(message, text = null, options = {}) {
  return window.NotificationService?.warning(message, text, options) ||
         window.alert(message)
}

// Info notification
export function info(message, text = null, options = {}) {
  return window.NotificationService?.info(message, text, options) ||
         window.alert(message)
}

// Toast notification (non-blocking)
export function toast(message, type = "info", options = {}) {
  return window.NotificationService?.toast(message, type, options)
}

// Loading state
export function showLoading(title = null, text = null) {
  return window.NotificationService?.showLoading(title, text)
}

// Close any notification
export function close() {
  return window.NotificationService?.close()
}

// Input prompt
export function prompt(title, options = {}) {
  return window.NotificationService?.prompt(title, options) ||
         Promise.resolve(window.prompt(title))
}

// Make globally accessible for backwards compatibility
if (typeof window !== 'undefined') {
  // Override native alert and confirm for seamless replacement
  window.originalAlert = window.alert
  window.originalConfirm = window.confirm
  
  // Note: We keep the original functions as fallbacks and don't override
  // the native ones to avoid breaking third-party libraries
  window.notify = {
    alert,
    confirm,
    confirmDelete,
    success,
    error,
    warning,
    info,
    toast,
    showLoading,
    close,
    prompt
  }
}